/**
 * TSV – Floating Cart Button (FAB)
 * Extracted from theme.liquid for cacheability.
 */
(function(){
  var fab = document.getElementById('tsv-fab-cart');
  if (!fab) return;

  var cartIcon = document.querySelector('#cart-icon-bubble');
  var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

  // 1) Show after scroll
  var SHOW_AFTER = 240;
  var onScroll = function(){
    if (window.scrollY > SHOW_AFTER) fab.classList.add('is-visible');
    else fab.classList.remove('is-visible');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // 2) Badge sync from existing bubble
  var badge = fab.querySelector('.tsv-fab__badge');

  var readCount = function(){
    if (!bubble) return 0;
    var hidden = bubble.querySelector('span[aria-hidden="true"]');
    var txt = (hidden ? hidden.textContent : bubble.textContent) || '';
    var n = parseInt(txt.replace(/[^\d]/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  };

  var renderBadge = function(){
    var count = readCount();
    if (!badge) return;
    if (count > 0) {
      badge.style.display = 'block';
      badge.textContent = count > 9 ? '9+' : String(count);
    } else {
      badge.style.display = 'none';
      badge.textContent = '';
    }
  };

  // Observe changes to the existing bubble
  if (bubble) {
    var mo = new MutationObserver(renderBadge);
    mo.observe(bubble, { subtree: true, characterData: true, childList: true });
  }

  // Also set initial badge
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(cart){
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : readCount();
      if (!badge) return;
      if (count > 0) {
        badge.style.display = 'block';
        badge.textContent = count > 9 ? '9+' : String(count);
      } else {
        badge.style.display = 'none';
      }
    })
    .catch(renderBadge);

  // 3) Open drawer via existing cart icon click
  fab.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    if (cartIcon) cartIcon.click();
  });
})();